import { Box } from '@palmetto/palmetto-components';
import { DateTime } from 'luxon';

export function LeadManagementTimeToAccept({ expiresAt }: { expiresAt: string }) {
  const currentTime = DateTime.utc();
  const expiry = DateTime.fromISO(expiresAt, { zone: 'utc' });
  const diff = expiry.diff(currentTime, ['days', 'hours', 'minutes']);

  const days = Math.floor(diff.days);
  const hours = Math.floor(diff.hours);
  const minutes = Math.floor(diff.minutes);

  let label: string;
  if (days >= 1) {
    label = `${days} day${days > 1 ? 's' : ''}`;
  } else if (hours >= 1) {
    label = `${hours} hour${hours > 1 ? 's' : ''}`;
  } else {
    label = `${minutes} minute${minutes !== 1 ? 's' : ''}`;
  }

  const isUrgent = days < 1;

  return (
    <Box fontSize="sm" color={isUrgent ? 'danger' : undefined} fontWeight={isUrgent ? 'medium' : 'regular'}>
      {label}
    </Box>
  );
}
